export const OSS_PREFIX = 'https://kidopally-app.oss-cn-beijing.aliyuncs.com';
